<template>
  <SelectButton
    v-model="store"
    :options="options"
    optionLabel="label"
    optionValue="value"
    :allowEmpty="false"
    class="w-full"
  >
    <template #option="slotProps">
      <component :is="slotProps.option.icon" class="w-4 h-4" />
      <span>{{ slotProps.option.label }}</span>
    </template>
  </SelectButton>
</template>

<script lang="ts" setup>
import { useColorMode } from '@vueuse/core'
import SelectButton from 'primevue/selectbutton'

import ComputerDesktopIcon from '@/assets/computerDesktop.svg?component'
import MoonIcon from '@/assets/moon.svg?component'
import SunIcon from '@/assets/sun.svg?component'

const { store } = useColorMode()

const options = [
  { label: 'Light', value: 'light', icon: SunIcon },
  { label: 'Dark', value: 'dark', icon: MoonIcon },
  { label: 'Auto', value: 'auto', icon: ComputerDesktopIcon },
]
</script>
